import React from 'react';

interface CircleIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CircleIcon: React.FC<CircleIconProps> = ({  ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      // eslint-disable-next-line max-len
      d="M10 2C5.58187 2 2 5.58187 2 10C2 14.4181 5.58187 18 10 18C14.4181 18 18 14.4181 18 10C18 5.58187 14.4181 2 10 2Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default CircleIcon;
